import { ARRIVED_STATUSES } from 'constants/shipments'

export enum units {
  M = 'm',
  K = 'k',
  N = 'N',
}

export const calculateDistance = (
  lat1?: string,
  lon1?: string,
  lat2?: string,
  lon2?: string,
  unit: units = units.M
): number => {
  if (!(lat1 && lat2 && lon1 && lon2)) return -1
  if (lat1 === lat2 && lon1 === lon2) return 0
  const radlat1: number = (Math.PI * Number(lat1)) / 180
  const radlat2: number = (Math.PI * Number(lat2)) / 180
  const theta: number = Number(lon1) - Number(lon2)
  const radtheta: number = (Math.PI * theta) / 180
  let dist: number =
    Math.sin(radlat1) * Math.sin(radlat2) +
    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
  if (dist > 1) {
    dist = 1
  }
  dist = Math.acos(dist)
  dist = (dist * 180) / Math.PI
  dist = dist * 60 * 1.1515
  if (unit === units.K) {
    dist *= 1.609344
  } else if (unit === units.M) {
    dist *= 0.8684
  }
  return Number(dist.toFixed(2))
}

interface LocationTypes {
  latitude: string
  longitude: string
}

export const atLocation = (
  loc1?: LocationTypes,
  loc2?: LocationTypes,
  status?: string
): boolean => {
  const distanceToStop: number = calculateDistance(
    loc1?.latitude,
    loc1?.longitude,
    loc2?.latitude,
    loc2?.longitude
  )
  return (distanceToStop >= 0 && distanceToStop < 1) || ARRIVED_STATUSES.includes(status || '')
}
